var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_32_49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.375 35.625H0.625V39.375H39.375V35.625Z",
    fill: "white",
    stroke: "#2D142C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.625 31.25H4.375L0.625 35.625H39.375L35.625 31.25Z",
    fill: "white",
    stroke: "#2D142C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.625 11.25H4.375V31.25H35.625V11.25Z",
    fill: "white",
    stroke: "#2D142C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.5 28.125V14.375L7.5 14.375V28.125H32.5Z",
    fill: "#EE4540",
    stroke: "#2D142C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.375 37.5H15.625",
    stroke: "#2D142C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20 14.875L17.5 16.5438V19.4688C17.759 19.8911 18.1293 20.2341 18.5702 20.4601C19.0112 20.6861 19.5058 20.7864 20 20.75C20.4942 20.7864 20.9888 20.6861 21.4298 20.4601C21.8707 20.2341 22.241 19.8911 22.5 19.4688V16.5438L20 14.875Z",
    fill: "white",
    stroke: "#2D142C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M26.25 6.875C26.25 5.88468 26.0147 4.90853 25.5634 4.027C25.1121 3.14547 24.4578 2.38379 23.6544 1.80474C22.851 1.22568 21.9216 0.845832 20.9426 0.696482C19.9636 0.547133 18.9631 0.632562 18.0236 0.94573C17.0841 1.2589 16.2324 1.79084 15.5388 2.49772C14.8453 3.2046 14.3296 4.06618 14.0343 5.01145C13.739 5.95673 13.6726 6.95865 13.8405 7.93463C14.0084 8.91062 14.4058 9.83274 15 10.625C15 10.625 17.5 13.75 17.5 16.25C17.5 16.875 18.75 17.5 20 17.5C21.25 17.5 22.5 16.875 22.5 16.25C22.5 13.75 25 10.625 25 10.625C25.8114 9.54315 26.25 8.22731 26.25 6.875Z",
    fill: "white",
    stroke: "#2D142C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.25 16.25V7.5",
    stroke: "#2D142C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.75 16.25V7.5",
    stroke: "#2D142C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.75 9.375H21.25",
    stroke: "#2D142C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout1);
export default __webpack_public_path__ + "static/media/about1.5bd1c0519fde5522bde40d4258c27fb4.svg";
export { ForwardRef as ReactComponent };